import { faCalendar, faHourglassEnd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StringToDate from '../../../util/StringToDate';
import { differenceInDays } from 'date-fns';
import { useSelector } from "react-redux";
//Отобразит Дату начала/завершения задачи
function DateStartEnd({ date_start, date_end, date_completed }) {
    //date_start - Дата постановки задачи
    //date_end - Дата окончания задачи(до какой даты должна быть завершена задача)
    //date_completed - Фактическая дата завершения

    const stateSize = useSelector((state) => state.size);

    if (date_start !== null & date_end !== null) {
        const diff_days = date_completed == null ?
            differenceInDays(new Date(), new Date(date_end))
            :
            differenceInDays(new Date(date_completed), new Date(date_end))

        return (
            stateSize.desktop === true ? (
                <>
                    <FontAwesomeIcon icon={faCalendar} className='mr-5' />{StringToDate(date_start)} - {StringToDate(date_end)}
                    {diff_days > 0 && <div className='text-danger'><b><FontAwesomeIcon icon={faHourglassEnd} className='mr-5' /> Просрочено {diff_days} дн.</b></div>}
                </>
            )
                :
                (
                    <div style={{ fontSize: '8px' }}>
                        <FontAwesomeIcon icon={faCalendar} className='mr-5' />{StringToDate(date_start)} - {StringToDate(date_end)}
                        {diff_days > 0 && <div className='text-danger' ><b><FontAwesomeIcon icon={faHourglassEnd} /> Просрочено {diff_days} дн.</b></div>}
                    </div>
                )
        )
    }
    else if (date_start !== null & date_end === null) {
        return (<><FontAwesomeIcon icon={faCalendar} className='mr-5' />С {StringToDate(date_start)}</>)
    }
    else {
        return null;
    }
}
export default DateStartEnd;